import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DatatableTables from "./DatatableTables"
import MetaTag from "components/Common/Meta-tag"

function AreaList() {
  return (
    <>
      <MetaTag title={"Available Areas"} />

      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="Available Areas" />
        <Container fluid>
          <div className="container-fluid">
            <DatatableTables />
          </div>
        </Container>
      </div>
    </>
  )
}

export default AreaList
